import { values } from '@fortem-monorepo/js-utilities';
export const INDEX_TYPE = {
    Equity: 'Equity',
    Fx: 'FX',
    Rate: 'Rate',
    Cds: 'CDS',
    Commodity: 'Commodity',
    Bond: 'Bond',
    Inflation: 'Inflation',
};
export const INDEX_TYPES = values(INDEX_TYPE);
